import React from "react";
import ImageOf404 from "../../assets/6339704.jpg";
import "./NotFound.css";

function NotFound() {
  return (
    <div className="w-screen h-screen flex justify-center border-solid border-2 border-slate-500">
      <img src={ImageOf404} alt="_blank" className="imgSection " />
    </div>
  );
}

export default NotFound;
